import RelativeTimeLabel from './RelativeTimeLabel';

export default RelativeTimeLabel;
